var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { APP_STORE } from '@/stores/defs';
var mixinName = {
    computed: __assign({}, mapGetters({
        welcome_getShowNewStore: APP_STORE.GET_NEW_STORE_WELCOME,
    })),
    methods: __assign({}, mapActions({
        welcome_setShowNewStore: APP_STORE.SET_NEW_STORE_WELCOME,
    })),
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/welcomeMixin.ts
// module id = tv3A
// module chunks = 18